export default "__VITE_ASSET__74e91da4__"